import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import TextInput from '@components/application/input/textInput';

const LocationQuestion = ({ setLocation, setView, location }) => {
  const postcodeRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (postcodeRef.current.handleValidation()) {
      setLocation(event.target.postcode.value.toUpperCase());
      setView('deliveryOptions');
    }
  };

  return (
    <div className="do-section">
      <div className="do-question ch-text--balance">
        Tell us where you are to see your Click & Collect options.
      </div>
      <form
        className="ch-display--flex ch-justify-content--center"
        onSubmit={handleSubmit}
      >
        <TextInput
          additionalErrorMessageClasses="ch-color--ac-red"
          additionalInputClasses="do-location--input"
          additionalLabelClasses="ch-hide"
          autocomplete="postal-code"
          errorMessage="Please enter a valid postcode."
          inputId="postcode"
          inputName="postcode"
          placeholder="Enter postcode"
          ref={postcodeRef}
          requiresPostcodeValidation
          storeKey="postcode"
          value={location}
        />
        <button
          className="ch-btn ch-btn--primary do-location--btn"
          type="submit"
        >
          Search
        </button>
      </form>
    </div>
  );
};

export default LocationQuestion;

LocationQuestion.propTypes = {
  location: PropTypes.string,
  setLocation: PropTypes.func,
  setView: PropTypes.func,
};
